var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center"},[_c('div',{attrs:{"id":"building"}},[_c('v-img',{attrs:{"id":"entrance","src":_vm.isOpen ? _vm.srcOpen : _vm.srcClose,"lazy":""},on:{"click":_vm.enter,"mouseover":function($event){_vm.isOpen = true},"mouseleave":function($event){_vm.isOpen = false}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }